// @flow

const openExternalLink = (url: string) => {
  window.open(url, "_blank", "location=yes,height=800,width=1200");
};
export default openExternalLink;
